module.exports = __webpack_public_path__ + "static/img/d-img.8d1fb143.jpg";